import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/main.css';

const DashboardTable = () => {
  const [taskData, setTaskData] = useState([]);
  const [projectNames, setProjectNames] = useState({});
  const [viewMode, setViewMode] = useState('today'); // 'today' or 'due'

  const todayStr = new Date().toISOString().split('T')[0];
  const todayDate = new Date(todayStr);

  // Fetch task data
  useEffect(() => {
    axios
      .get('/api/mainuser.php?action=tasks', { withCredentials: true })
      .then((res) => setTaskData(res.data))
      .catch((err) => console.error('Fetch error:', err));
  }, []);

  // Fetch project names
  useEffect(() => {
    fetch('/api/projectname.php?method=getNames')
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setProjectNames(data.projects);
        }
      });
  }, []);

  // Filter tasks based on selected view
  const filteredTasks =
    viewMode === 'today'
      ? taskData.filter((task) => task.start_date === todayStr)
      : taskData.filter((task) => {
          const taskDate = new Date(task.start_date);
          return (
            taskDate < todayDate &&
            (task.status === 'To Do' || task.status === 'Hold')
          );
        });

  return (
    <div className='flex gap-1 justify-between'>
    <div className="mt-10 px-6 w-[65%]">
      {/* Content Switcher */}
      <div className="flex gap-3 mb-2 ">
        <button
          onClick={() => setViewMode('today')}
          className={`text-xs font-semibold p-1 px-2 rounded-sm ${
            viewMode === 'today'
              ? 'text-white bg-gray-700'
              : 'text-gray-700 bg-white shadow-xl'
          }`}
        >
          📅 Today
        </button>
        <button
          onClick={() => setViewMode('due')}
          className={`text-xs font-semibold p-1 px-2 rounded-sm ${
            viewMode === 'due'
              ? 'text-white bg-gray-700'
              : 'text-gray-700 bg-white shadow-xl'
          }`}
        >
          ⏰ Due Tasks
        </button>
      </div>

      {/* Task Table */}
      <div className='overflow-y-auto max-h-40  scrollbar-hide rounded-lg  shadow-lg'>
        <table className="w-full divide-y divide-gray-200  ">
          <thead className="bg-gray-700 sticky top-0 z-0">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                Project Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                Task Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                Tentative Time
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 ">
            {filteredTasks.length > 0 ? (
              filteredTasks.map((task, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-3 text-xs text-gray-700 whitespace-nowrap">
                    {projectNames[task.project_id] || (
                      <span className="bg-gray-300 px-2 py-1 rounded shadow-xl text-gray-800 font-semibold text-xs">
                        Single Task
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-3 text-xs text-gray-700 whitespace-nowrap">{task.task_name}</td>
                  <td className="px-6 py-3 text-xs text-gray-700 whitespace-nowrap">
                    {task.submission_date}hr
                  </td>
                  <td></td>
                </tr>
              ))
            ) : (
              <tr >
                <td colSpan="4" className="text-center py-4 text-sm text-gray-500">
                  {viewMode === 'today'
                    ? 'No tasks starting today.'
                    : 'No due tasks with status To Do or Hold.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
     
    </div>

     <div className='bg-white overflow-y-auto max-h-50 shadow-lg w-[33%] mt-8 rounded-sm mr-8'>
        <div className=' flex gap-2 mt-2 pl-2 border-b pb-2 border-gray-300'>
          <button className='text-xs font-semibold p-1 px-2 rounded-sm text-gray-700 bg-gray-100 shadow-sm'>Issue</button>
          <button className='text-xs font-semibold p-1 px-2 rounded-sm text-gray-700 bg-gray-100 shadow-sm ' >Change</button>
        </div>
        
      </div>
    </div>
  );
};

export default DashboardTable;
